import React from "react";
import useScrollReset from "@hooks/ScrollHook";

export default function NotFoundPage() {
    useScrollReset()

    return (
        <main className="pt-[5.5rem] lg:pt-24 flex align-center justify-center">
            <h1 className="text-2xl">404 Not found!</h1>
        </main>
    )
}